/**
 * Sticky add-to-cart bar for the LED masker product template.
 * Shows the bar once the hero's own add-to-cart button has scrolled out of
 * view, hides it again once it's back in view. The bar's button submits the
 * existing hero product form via the HTML form="" attribute, so no separate
 * cart request is made here (keeps Shopify/Meta Pixel analytics intact).
 */
(function () {
  var stickyBar = document.querySelector('[data-led-masker-sticky-cta]');
  var heroCta = document.querySelector('[data-led-masker-hero-cta]');

  if (!stickyBar || !heroCta || typeof IntersectionObserver === 'undefined') {
    return;
  }

  stickyBar.hidden = false;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          stickyBar.classList.remove('is-visible');
        } else if (entry.boundingClientRect.top < 0) {
          stickyBar.classList.add('is-visible');
        } else {
          stickyBar.classList.remove('is-visible');
        }
      });
    },
    { threshold: 0 }
  );

  observer.observe(heroCta);
})();
